(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["valsole-before-after-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);
    const readNumber = (value, fallback) => {
      const parsed = Number.parseFloat(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const initBeforeAfter = (section) => {
      const range = section.querySelector('[data-vs-ba-range]');
      if (!range) return () => {};

      const setPosition = () => {
        section.style.setProperty('--vs-ba-position', `${range.value}%`);
      };

      const autoEnabled = section.dataset.vsBaAutoEnabled === 'true';
      const autoStart = clamp(readNumber(section.dataset.vsBaAutoStart, range.value), 0, 100);
      const autoEnd = clamp(readNumber(section.dataset.vsBaAutoEnd, range.value), 0, 100);
      const autoDelay = clamp(readNumber(section.dataset.vsBaAutoDelay, 500), 0, 5000);
      const autoDuration = clamp(readNumber(section.dataset.vsBaAutoDuration, 1400), 200, 8000);

      const cancelAuto = () => {
        section.dataset.vsBaAutoCancelled = 'true';
      };

      const runAutoSlide = () => {
        if (!autoEnabled || prefersReducedMotion()) return;
        if (section.dataset.vsBaAutoPlayed === 'true' || section.dataset.vsBaAutoCancelled === 'true') return;
        section.dataset.vsBaAutoPlayed = 'true';

        range.value = autoStart;
        setPosition();

        window.setTimeout(() => {
          if (section.dataset.vsBaAutoCancelled === 'true') return;
          const startTime = performance.now();
          const distance = autoEnd - autoStart;

          const tick = (now) => {
            if (section.dataset.vsBaAutoCancelled === 'true') return;
            const progress = clamp((now - startTime) / autoDuration, 0, 1);
            range.value = autoStart + distance * easeOutCubic(progress);
            setPosition();
            if (progress < 1) requestAnimationFrame(tick);
          };

          requestAnimationFrame(tick);
        }, autoDelay);
      };

      range.addEventListener('pointerdown', cancelAuto, { passive: true });
      range.addEventListener('touchstart', cancelAuto, { passive: true });
      range.addEventListener('keydown', cancelAuto);
      range.addEventListener('input', () => {
        cancelAuto();
        setPosition();
      }, { passive: true });
      range.addEventListener('change', setPosition, { passive: true });

      if (autoEnabled) {
        range.value = autoStart;
      }
      setPosition();
      return runAutoSlide;
    };

    const initReveal = (section, onVisible) => {
      if (prefersReducedMotion()) {
        section.classList.add('is-visible');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        onVisible();
        return;
      }

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          onVisible();
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.35 });

      observer.observe(section);
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-vs-before-after]').forEach((section) => {
        if (section.dataset.vsBeforeAfterReady === 'true') return;
        section.dataset.vsBeforeAfterReady = 'true';
        const runAutoSlide = initBeforeAfter(section);
        initReveal(section, runAutoSlide);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valsole-count-up-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);

    const formatNumber = (value, decimals) => {
      return value.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    };

    const formatCompact = (value, target) => {
      if (target >= 1000000) {
        const compactValue = value / 1000000;
        const decimals = compactValue < 10 && compactValue % 1 !== 0 ? 1 : 0;
        return `${formatNumber(compactValue, decimals)}M`;
      }

      if (target >= 100000) {
        const compactValue = value / 1000;
        return `${formatNumber(compactValue, 0)}K`;
      }

      return formatNumber(value, target % 1 === 0 ? 0 : 1);
    };

    const animateCard = (number) => {
      if (number.dataset.vsCountAnimated === 'true') return;
      number.dataset.vsCountAnimated = 'true';

      const output = number.querySelector('[data-vs-count-value]');
      const rawTarget = Number.parseFloat(number.dataset.target.replace(/,/g, ''));
      if (!output || Number.isNaN(rawTarget)) return;

      const start = performance.now();
      const duration = rawTarget >= 100000 ? 1850 : 1450;
      if (rawTarget >= 10000) {
        number.classList.add('is-long-number');
      }
      number.classList.add('is-counting');

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        output.textContent = formatCompact(rawTarget * easeOutCubic(progress), rawTarget);
        if (progress < 1) {
          requestAnimationFrame(tick);
          return;
        }
        output.textContent = formatCompact(rawTarget, rawTarget);
        number.classList.remove('is-counting');
      };

      requestAnimationFrame(tick);
    };

    const reveal = (section) => {
      section.classList.add('is-visible');
      section.querySelectorAll('[data-vs-count-number]').forEach(animateCard);
    };

    const initSection = (section) => {
      if (section.dataset.vsCountReady === 'true') return;
      section.dataset.vsCountReady = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        reveal(section);
        return;
      }

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.25 });

      observer.observe(section);
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-vs-count-up]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
